import { useMemo } from 'react';
import { getChangeLogDateTimeString } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/utils';

type ChangeLogAccommodationDatesProps = {
  checkInAt: string | null;
  checkOutAt: string | null;
};

export const ChangeLogAccommodationDates = ({ checkInAt, checkOutAt }: ChangeLogAccommodationDatesProps) => {
  const checkInDateString = useMemo(() => {
    if (!checkInAt) return null;
    return getChangeLogDateTimeString(checkInAt, 'MMM d yyyy');
  }, [checkInAt]);

  const checkOutDateString = useMemo(() => {
    if (!checkOutAt) return null;
    return getChangeLogDateTimeString(checkOutAt, 'MMM d yyyy');
  }, [checkOutAt]);

  if (!checkInDateString && !checkOutDateString) return null;

  const textValue = [
    ...(checkInDateString ? [`Check in date: ${checkInDateString}`] : []),
    ...(checkOutDateString ? [`Check out date: ${checkOutDateString}`] : []),
  ].join(' - ');

  return <span className="text-s-r text-base-20 pt-0.5">{textValue}</span>;
};
